/*
 * File: /src/stores/shop.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 16th July 2018 1:51:25 pm
 * Last Modified: Wednesday, 21st November 2018 12:07:21 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
import moment from 'moment'

const initialState = () => ({
    domain: null,
    charge: null,
    plan: null,
    id: null
})

const state = () => initialState()

const actions = {
    async START_SESSION({ commit, dispatch }) {
        try {
            const { shop } = await dispatch(
                'shopifyApi/REQUEST',
                {
                    endpoint: 'session'
                },
                { root: true }
            )

            commit('SET_DOMAIN', { domain: shop })
            return shop
        } catch (error) {
            console.error('shop/START_SESSION', { error })
            throw error
        }
    },

    async GET_SHOP_PLAN({ commit, dispatch }) {
        try {
            const { plan, id } = await dispatch(
                'shopifyApi/REQUEST',
                {
                    endpoint: 'shop'
                },
                { root: true }
            )

            commit('SET_PLAN', { plan })
            commit('SET_ID', { id })
            return plan
        } catch (error) {
            console.error('shop/GET_SHOP_PLAN', { error })
            throw error
        }
    },

    async GET_SHOP_CHARGE({ commit, dispatch }) {
        try {
            const { charge } = await dispatch(
                'shopifyApi/REQUEST',
                {
                    endpoint: 'payment'
                },
                { root: true }
            )

            commit('SET_CHARGE', { charge })
            return charge
        } catch (error) {
            console.error('shop/GET_SHOP_PAYMENT', { error })
            throw error
        }
    },

    async CHARGE_CREATE({ commit, dispatch }) {
        // console.log('CHARGE_CREATE')
        try {
            const { charge } = await dispatch(
                'shopifyApi/REQUEST',
                {
                    endpoint: 'payment',
                    method: 'POST'
                },
                { root: true }
            )

            commit('SET_CHARGE', { charge })
            return charge
        } catch (error) {
            console.error('shop/GET_SHOP_PAYMENT', { error })
            throw error
        }
    },

    async CHARGE_CONFIRM({ commit, dispatch }, { chargeId }) {
        // console.log('CHARGE_CONFIRM')
        try {
            const { charge } = await dispatch(
                'shopifyApi/REQUEST',
                {
                    endpoint: `payment/confirm/${chargeId}`,
                    method: 'POST'
                },
                { root: true }
            )

            commit('SET_CHARGE', { charge })
            return charge
        } catch (error) {
            console.error('shop/CHARGE_CONFIRM', { error })
            throw error
        }
    },

    async GET_PRODUCTS({ dispatch }) {
        try {
            const response = await dispatch(
                'shopifyApi/REQUEST',
                {
                    endpoint: 'products'
                },
                { root: true }
            )

            // console.log('shop/GET_PRODUCTS', response)

            return response
        } catch (error) {
            console.error('shop/GET_PRODUCTS', { error })
            throw error
        }
    }
}

const mutations = {
    SET_DOMAIN(state, { domain }) {
        console.log('🏪 Setting Domain:', {
            previousDomain: state.domain,
            newDomain: domain,
            isClearing: domain === null
        })
        state.domain = domain
    },

    SET_CHARGE(state, { charge }) {
        console.log('💳 Setting Charge:', {
            previousCharge: state.charge,
            newCharge: charge
        })
        state.charge = charge
    },

    SET_PLAN(state, { plan }) {
        console.log('📋 Setting Plan:', {
            previousPlan: state.plan,
            newPlan: plan
        })
        state.plan = plan
    },

    SET_ID(state, { id }) {
        console.log('🆔 Setting ID:', {
            previousId: state.id,
            newId: id
        })
        state.id = id
    }
}

const getters = {
    domain: state => state.domain,
    charge: state => state.charge,
    plan: state => state.plan,
    id: state => state.id,
    isPlanDev: state => {
        return (
            state.plan &&
            (state.plan === 'trial' || state.plan === 'affiliate' || state.plan === 'partner_test')
        )
    },
    chargeDaysLeft: state => {
        if (!state.charge || !state.charge.trial_ends_on) {
            return 0
        }
        let endDate = moment(state.charge.trial_ends_on).utc()
        let currentDate = moment().utc()
        let diff = endDate.diff(currentDate, 'days') + 1

        return diff
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/stores/shop.js